import { AxiosInstance } from 'axios';
import { WhereaboutsCheckSettingRepository } from '@/model/repository/manager/whereaboutsCheck/WhereaboutsCheckSettingRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): WhereaboutsCheckSettingRepository => ({
    index() {
      return Repository.get(resource);
    },
    update(payload) {
      return Repository.post(resource, payload);
    },
  });
